import { Chart } from 'angular-highcharts';
declare var require: any;
const Highcharts = require('highcharts');
export class Charts {

  pieChart(obj) {
    Highcharts.setOptions({ lang: { thousandsSep: ',' } });
    return new Chart({
      credits: {
      enabled: false
        },
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: obj.title
      },
      tooltip: {
          pointFormat: obj.tooltip
      },
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                  enabled: false,
                  format: obj.label,
              },
              showInLegend: true
          }
      },
      series: obj.data
    });
  }

  graph(obj) {
    return new Chart({
      title: { text: obj.title },
      subtitle: { text: obj.subtitle },
      yAxis: {
        title: {
          text: 'Revenue from departments'
        }
      },
      xAxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
              'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },
      legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
      },
      series: obj.data
    })
  }


  barGraph(obj,xData) {
    return new Chart({
    chart: {
        type: 'column'
    },
     credits: {
      enabled: false
        },
    title: { text: obj.title },
    subtitle:  { text: obj.subtitle },
    xAxis: {
        categories: [''],
        crosshair: false
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Orders'
        }
    },
    // tooltip: {
    //     headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    //     pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
    //         '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
    //     footerFormat: '</table>',
    //     shared: true,
    //     useHTML: true
    // },
    plotOptions: {
        column: {
            pointPadding: 0.2,
            borderWidth: 0
        }
    },
    series: obj.data
})
  }

}



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/shared/charts.ts